import React from "react";

const OrderCreationTenderIcon = ({ color = "#6D7885", ...rest }) => {
  return (
    <svg preserveAspectRatio="none" overflow="visible" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g>
        <path d="M20 2H8C7.46957 2 6.96086 2.21071 6.58579 2.58579C6.21071 2.96086 6 3.46957 6 4V16C6 16.5304 6.21071 17.0391 6.58579 17.4142C6.96086 17.7893 7.46957 18 8 18H20C20.5304 18 21.0391 17.7893 21.4142 17.4142C21.7893 17.0391 22 16.5304 22 16V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2ZM13.067 14.481L9.793 11.207L11.207 9.793L12.933 11.519L17.232 6.36L18.769 7.641L13.067 14.481Z" fill={color} />
        <path d="M4 22H15V20H4V8H2V20C2 21.103 2.897 22 4 22Z" fill={color} />
      </g>
    </svg>
  );
};

export default OrderCreationTenderIcon;
